<template>
  <div>
   <v-text-field v-model="address.street" required :rules="rules.street">
        <template slot="label">
           Street<span class='star'>*</span>
        </template>
    </v-text-field>

    <v-text-field v-model="address.city" required :rules="rules.city">
        <template slot="label">
           City<span class='star'>*</span>
        </template>
    </v-text-field>

    <v-text-field v-model="address.state" required :rules="rules.state">
        <template slot="label">
           State<span class='star'>*</span>
        </template>
    </v-text-field>

    <v-text-field class="zip" v-model="address.zip" required :mask="mask" :rules="rules.zip">
        <template slot="label">
           Zip<span class='star'>*</span>
        </template>
    </v-text-field>
  </div>
</template>
<style lang="scss" scoped>
.zip {
  width: 8em;
}
</style>
<script>
export default {
  props: ["address"],
  computed: {},
  data() {
    return {
      "mask": "#####",
      "rules": {
        street: [v => !!v || "Street is required."],
        city: [v => !!v || "City is required."],
        state: [v => !!v || "State is required."],
        zip: [v => !!v || "Zip code is required."]
      }
    };
  },
  methods: {
    ohyeah() {

    }
  },
  mounted() {
    // Do some addressy stuff.
  }
};
</script>
